import React from 'react'
import PropTypes from 'prop-types'
import { Link, StaticQuery, graphql } from 'gatsby'
import Header from '../components/Header'

export default class IndexPage extends React.Component {
  render() {
    const { posts, title } = this.props

    return (
    <>
    <Header>Vijesti</Header>
      <section className="section">
        <div className="container">
          <div className="container-info">
            <div className="text-promo-header">
              <h4 className="text-promo-large">Pročitajte intervjue i najnovije vijesti sa SFF-a</h4>
            </div>
          </div>
          <div className="info-row">
            {posts.map(({ node: post }) => (
            <div key={post.id} className="info-col-two">
              <div className="blog-post">
                <div
                className="content naslovi"
                style={{ border: 'none' }}
                >
                  <p className="post-header">
                    <Link className="has-text-primary" to={post.slug}>
                      {post.title}
                    </Link>
                        <br />
                    <small className="small-date">
                      {post.date}
                    </small>
                  </p>  
                </div>
                <div className="featured-image">
                  <img src={post.featured_media.localFile.childImageSharp.fluid.src}/>
                </div>
                <div
                className="content tekstovi"
                style={{ border: 'none' }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: post.excerpt.replace(/<p class="link-more.*/, ''),
                    }}
                  />
                  <Link className="button is-small" to={post.slug}>
                    Čitaj dalje →
                  </Link>
                </div>
              </div>
            </div>
            ))}
          </div>
        </div>
      </section>
      </>
    )
  }
}

IndexPage.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export const pageQuery = graphql`
  fragment PostListFields on wordpress__POST {
    id
    title
    excerpt
    author {
      name
      slug
    }
    content
    featured_media {
      localFile {
        childImageSharp {
          fluid {
            src
          }
        }
      }
    }
    date(formatString: "DD.MM.YYYY")
    slug
  }
`
